const setVaccine = (state, vaccine) => (state.vaccine = vaccine);

const setVaccines = (state, vaccines) => (state.vaccines = vaccines);

let mutations = {
  setVaccine,
  setVaccines
};

export default mutations;
